<template>
 <div class="mt-2" v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.GRN))">
    <v-container fluid class="mb-2">
        <v-row style="height: 100%;" class="pl-4" >
<v-col md="12">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>User Management</h4>
          </v-toolbar>
                 <GRNUserManagement/>
</v-col>
      </v-row>

    </v-container>
 </div>
</template>
<script>
import GRNUserManagement from '../components/GRNUserManagement.vue'
import { mapGetters } from 'vuex'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins:[accessControlMixin],
   data(){
       return{

       }
   },
    mounted () {
    if (this.user.roles && (!this.user.roles.includes('*') && !this.userHasResourceAccess(this.RESOURCENAMES.GRN) && !this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT))) {
      if (this.$route && this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  },
   components:{
       GRNUserManagement
   },
    computed: {
    ...mapGetters(['getUserLoggedIn']),
    user () {
      return this.getUserLoggedIn
    }
  }
}
</script>
